export default "__VITE_ASSET__CQWUmFAU__"